import { useState, useEffect } from "react";

/**
 * @param endTimeString ISO 문자열 혹은 그냥 Date로 변환 가능한 값
 * @returns {
 *   remainingSeconds: number;  // 남은 시간(초)
 *   formatted: string;         // "MM:SS" 형태의 문자열
 * }
 */
export function useTimer(endTimeString?: string) {
  // 현재 시각(밀리초)
  const [currentTime, setCurrentTime] = useState(Date.now());

  useEffect(() => {
    // 1초마다 현재 시각을 갱신
    const timer = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // endTimeString이 주어지지 않으면 남은 시간은 0
  const endTime = endTimeString ? new Date(endTimeString).getTime() : 0;
  const rawSeconds = Math.max(0, Math.floor((endTime - currentTime) / 1000));

  // 분:초 형태로 포맷팅
  const minutes = Math.floor(rawSeconds / 60);
  const seconds = rawSeconds % 60;
  const formatted = `${minutes}:${seconds.toString().padStart(2, "0")}`;

  return {
    remainingSeconds: rawSeconds,
    formatted,
  };
}
